import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseDialogue from '../../Compound/ConfirmationDialogue/BaseDialogue';

import styles from '../Modal/Modal.module.scss';

export type ConfirmationDialogueProps = {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  visible?: boolean;
};

type FC = FunctionComponent<ConfirmationDialogueProps>;

const UserNavPrompt: FC = ({ message, onConfirm, onCancel, visible = true }: ConfirmationDialogueProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'UserNavPrompt' });
  const [displayClass, setDisplayClass] = useState('hidden');
  useEffect(() => {
    if (visible) {
      setDisplayClass('visible');
    } else {
      setDisplayClass('hidden');
    }
  }, [visible]);

  const handleConfirm = () => {
    onConfirm();
    setDisplayClass('hidden');
  };

  const handleCancel = () => {
    onCancel();
    setDisplayClass('hidden');
  };

  const handleBackgroundClick = () => {
    setDisplayClass('hidden');
  };

  return (
    <div
      className={[styles.container, styles[displayClass]].join(' ')}
      onClick={handleBackgroundClick}
      aria-hidden="true"
    >
      <div className={styles.content} onClick={(e) => e.stopPropagation()} aria-hidden="true">
        <BaseDialogue
          title={t('title', { defaultValue: 'Are you sure you want to navigate away from this page?' })}
          status="alert"
          subTitle={message}
          confirm={{ label: t('confirm', { defaultValue: 'Yes, Continue' }), action: handleConfirm }}
          cancel={{ label: t('cancel', { defaultValue: 'No, Stay Here' }), action: handleCancel }}
        />
      </div>
    </div>
  );
};

export default UserNavPrompt;
